import { Box, Chip, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { visuallyHiddenSx } from "styles/common/typography"

type PositivityTier = "high" | "medium" | "low"

// Compared on the displayed 1-decimal value, inclusive lower bounds.
const getPositivityTier = (shown: number): PositivityTier => {
  if (shown >= 80) return "high"
  if (shown >= 60) return "medium"
  return "low"
}

const POSITIVITY_TIER_SX: Record<PositivityTier, object> = {
  high: { bgcolor: "mockup.success90", color: "mockup.neutral10" },
  medium: { bgcolor: "mockup.secondary90", color: "mockup.neutral10" },
  low: { bgcolor: "mockup.error90", color: "mockup.neutral10" },
}

const PositivityChip = ({ positivity }: { positivity: number | null }) => {
  const { t } = useTranslation()

  if (positivity === null)
    return (
      <Typography variant="body3" color="mockup.neutral30">
        <span aria-hidden="true">—</span>
        <Box component="span" sx={visuallyHiddenSx}>
          {t("adminDashboard.positivityUnknown")}
        </Box>
      </Typography>
    )
  const shown = (positivity * 100).toFixed(1)
  const value = `${shown}%`
  const tier = getPositivityTier(Number(shown))
  return (
    <Chip
      size="small"
      label={
        <>
          <span aria-hidden="true">{value}</span>
          <Box component="span" sx={visuallyHiddenSx}>
            {t(`adminDashboard.positivityTier_${tier}`, { value })}
          </Box>
        </>
      }
      sx={POSITIVITY_TIER_SX[tier]}
    />
  )
}

export default PositivityChip
